export default __webpack_public_path__ + "static/media/heart-chase.ea8f622e.png";